import { initializeUtilities } from '@common/utils/globalUtilities';
import { CustomerApp } from '@customer/CustomerApp';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

if (module['hot']) {
    module['hot'].accept();
}
initializeUtilities();
function index() {
    return (
        <Router basename="/customer">
            <CustomerApp />
        </Router>
    );
}

const root = createRoot(document.getElementById("root")!);
root.render(index());
